define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/store/Memory",
	"csi",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/comm",
	"csi/comm/PostRequest",
	"csi/form/Widget",
	"csi/locale",
	"csi/util",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType",
	"./MassReplaceMaterialForm"
], function(array,declare,lang,Memory,csi,_,Controller,comm,PostRequest,FormWidget,locale,util,ActionControllerMixin,xml,Query,ProductType) {

	const FIELD_SECTION = "MaterialMassReplaceSection",
	FIELD_SCOPE = "MaterialMassReplaceScope",
	FIELD_COLOR = "MaterialMassReplaceColor",
	FIELD_FROM = "MaterialMassReplaceFrom",
	FIELD_TO = "MaterialMassReplaceTo",
	FIELD_RETAIN = "MaterialMassReplaceRetain",
	FIELD_THEME_BOM_RETAIN = "ThemeBOMMaterialMassReplaceRetain";
	FIELD_SYNCH_THEMES = "MaterialMassReplaceSynchThemes",

	SCOPE_MATERIAL = "Material",
	SCOPE_COLOR = "Color",
	SCOPE_COLOR_SPEC = "ColorSpec",
	SCOPE_COLOR_SPEC_TO_COLOR = "ColorSpecToColor",
	SCOPE_SIZE = "Size",
	SCOPE_QUOTE = "Quote",
	SCOPE_SOURCING_MODEL = "SourcingModel";

	return declare([Controller, ActionControllerMixin], {
		/**@override */
		bShowWait: true,

		// String: Material attribute to filter for "To" Materials (UsableForMaterial/StyleBOM)
		idBOMFilter: null,

		/** boolean: indicates whether the action is coming from WhereUsedThemeBOM */ 
		_isThemeBOMAction: false,

		getFormData: function() {
			// summary: make sure that at least one PartMaterial is selected
			var	fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = lang.hitch(this, this._canAggregatePlacement);
			return fd;
		},

		getStringParameters: function() {
			// summary: use return value as parameter to success message
			var	v = this.m_response ? this.m_response.getReturnValue() : null;

			if (v != null && !_.isArray(v)) {
				v = [v, 0];
			}

			return v;
		},

		onWizardViewPreCreate: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*View*/defView, /*Object*/viewParams) {
			// summary: notify when view definition for page is found and ready for creation with ability to add own viewParams
			var index = wizard.getIndexOfPage(page);
			if (index == 0) {
				viewParams._isThemeBOMAction = this._isThemeBOMAction;
			}
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for BOM-lines view
			let	q;

			if (index == 0) {
				// pass filter id to form
				view.idBOMFilter = this.idBOMFilter;
			} else {
				var	scope = this.m_formData.getFieldValue(FIELD_SCOPE);
				// Important to distinctify as some attributes for MaterialBOM and ApparelBOM do not exist for FoodBOM
				this._isFoodBOMAction = this.m_formData.getSource().widget.defView.m_id === "WhereUsedFoodBOM";

				q = new Query()
					.Node("Flags", xml.OP_BIT_0, xml.NODE_FLAG_FROZEN)

				if(this._isThemeBOMAction) {
					// C8-47073
					q.Attr2("Actual", xml.OP_BIT_0, {
						Flag: xml.ATTR_FLAG_NOEDIT
					});
				} else {
					q.Attr2("ThemeBOMSysID", xml.OP_EMPTY_STRING);
				}

				if (!this._isFoodBOMAction) {
					q.Attr("IsSampleBOM", xml.OP_EQUALS, false, "Child:__Parent__/Child:__Parent__");
				}

				if (scope == SCOPE_MATERIAL) {
					this._addProductStructureFixedMaterialConstraint(q);
					if (!this.m_formData.getFieldValue(FIELD_SYNCH_THEMES) && !this._isFoodBOMAction) {
						let q2 = q.Or();
						q2.RefAttr("FromMaterialPlanPlacement", xml.OP_EQUALS, csi.EMPTY_URL);
						q2.Attr("LockThemePlacementList", xml.OP_EQUALS, false, "Child:__Parent__/Child:__Parent__/Child:Subtype/Child:Settings");
					}
				} else if (scope == SCOPE_COLOR || scope == SCOPE_COLOR_SPEC) {
					var from = this.m_formData.getFieldValue(FIELD_FROM);
					q.Attr("ColorLock", xml.OP_EQUALS, false);
					if (from == csi.EMPTY_URL) {
						q.RefAttr("CommonColor", xml.OP_EQUALS, csi.EMPTY_URL);
					} else {
						q.RefAttr("UsedColors", xml.OP_EQUALS, from);
					}
				} else if (scope == SCOPE_COLOR_SPEC_TO_COLOR) {
					q.Attr("ColorLock", xml.OP_EQUALS, false);
					this._addFromFieldEquals(q, "UsedColors");
				} else if (scope == SCOPE_SIZE) {
					var from = this.m_formData.getFieldValue(FIELD_FROM);
					if (from == csi.EMPTY_URL) {
						q.RefAttr("CommonSize", xml.OP_EQUALS, csi.EMPTY_URL);
					} else {
						this._addFromFieldEquals(q, "UsedSizes");
					}
				} else if (scope == SCOPE_QUOTE) {
					var	color = this.m_formData.getFieldValue(FIELD_COLOR);
					if (color && color != csi.EMPTY_URL) {
						var q2 = q.Or();
						q2.RefAttr("UsedColors", xml.OP_EQUALS, color);
					}

					var	from = this.m_formData.getFieldValue(FIELD_FROM);
					if (from && from != csi.EMPTY_URL) {
						var q2 = q.Or();
						this._addFromFieldEquals(q2, "UsedQuotes");
					}
				}

				// filter by BOM section if one is selected
				var section = this.m_formData.getFieldValue(FIELD_SECTION);
				if (section && section != csi.EMPTY_URL)
					q.RefAttr("DSSection", xml.OP_EQUALS, section);

				if (!view.isStarted()) {
					// add existing filters from table view - only needs to be done first time
					view.copyQuery(this.widget);
				}
			}

			return q;
		},

		_addProductStructureFixedMaterialConstraint: function(q) {
			var material = this.m_cache.getNode(this.m_urlParent, true);
			if (ProductType.get(material, "MaterialUsage") == "MaterialUsage:StructureComponent") {
				q.Attr2("Actual", xml.OP_BIT_0, {
					Flag: xml.ATTR_FLAG_NOEDIT
				});
			}
		},

		_addFromFieldEquals: function(q, id) {
			q.RefAttr(id, xml.OP_EQUALS, this.m_formData.getFieldValue(FIELD_FROM));
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
		},

		process: function() {
			// summary: issue request based on scope
			var	fd = this.m_formData;
			var	scope = fd.getFieldValue(FIELD_SCOPE);
			var	req;

			if (scope == SCOPE_MATERIAL) {
				let serverModule, serverOperation;
				if (this._isFoodBOMAction) {
					serverModule = "FormulatedProduct";
					serverOperation = "FoodBOMLineItemMassReplaceMaterial";
				} else {
					serverModule = "Specification";
					serverOperation = "PartMaterialMassReplaceMaterial";
				}
				req = new PostRequest(serverModule, serverOperation)
					.addParameter("From", this.m_urlParent)
					.addParameter("To", fd.getFieldValue(FIELD_TO))
					.addParameter("RetainValues", this._isThemeBOMAction ? fd.getFieldValue(FIELD_THEME_BOM_RETAIN) : fd.getFieldValue(FIELD_RETAIN))
					.addParameter("SynchThemes", fd.getFieldValue(FIELD_SYNCH_THEMES));
			} else if (scope == SCOPE_QUOTE) {
			    var fieldForColor = fd.getFieldValue(FIELD_COLOR);
				req = new PostRequest("Specification", "PartMaterialMassReplaceQuote")
					.addParameter("For", this.m_urlParent)
					.addParameter("ForColor", fieldForColor ? fieldForColor : 'centric:')
					.addParameter("From", fd.getFieldValue(FIELD_FROM))
					.addParameter("To", fd.getFieldValue(FIELD_TO));
			} else if (scope == SCOPE_SOURCING_MODEL) {
				req = new PostRequest("Specification", "PartMaterialMassReplaceSourcingModel")
					.addParameter("For", this.m_urlParent)
					.addParameter("To", fd.getFieldValue(FIELD_TO));
			} else {
				var op;
				if (scope == SCOPE_SIZE) {
					op = "PartMaterialMassReplaceMaterialSize";
				} else {
					op = "PartMaterialMassReplaceMaterialColor";
				}
				req = new PostRequest("Specification", op)
					.addParameter("For", this.m_urlParent)
					.addParameter("From", fd.getFieldValue(FIELD_FROM))
					.addParameter("To", fd.getFieldValue(FIELD_TO));
			}

			var	nodes = fd.getSelectedNodes(true);
			if (nodes.length) {
				req.addParameter(xml.PROP_AGGREGATE_ADDS, array.map(nodes, xml.nodeGetURL));
			}
			// C8-50085: Temporary fix to defect with ProgressStep implementation (C8-50755)
			//req.addParameter("ProgressId", util.uuid());
			this.waitForPublish(req.post(), true);
		},

		postProcessSuccess: function() {
			// summary: refresh data in where used table
			this.widget.refreshData();
		},

		_canAggregatePlacement: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: only allow selection of nodes with Write access
			return xml.nodeHasRight(ctx.getNode(), xml.RIGHT_WRITE);
		},

		/** 
		 * @override
		 * return the success message for the action based on the view scope. Especially for ThemeBOM, the message is different.
		 *  */
		getSuccess: function() {
			return locale.resource(this._isThemeBOMAction ? "MassReplaceThemeBOM_Success" : "MassReplace_Success", this.getStringParameters());
		}
		
	});
});